import { render, staticRenderFns } from "./tabFile.vue?vue&type=template&id=3a41442a&scoped=true&"
import script from "./tabFile.vue?vue&type=script&lang=js&"
export * from "./tabFile.vue?vue&type=script&lang=js&"
import style0 from "./tabFile.vue?vue&type=style&index=0&id=3a41442a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41442a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a41442a')) {
      api.createRecord('3a41442a', component.options)
    } else {
      api.reload('3a41442a', component.options)
    }
    module.hot.accept("./tabFile.vue?vue&type=template&id=3a41442a&scoped=true&", function () {
      api.rerender('3a41442a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabFile.vue"
export default component.exports